import React from 'react';
import PropTypes from 'prop-types';

/**
 * UserFormsModal - Displays forms submitted by a user
 *
 * Shows a summary of form types and counts
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Object} props.userForms - Form data grouped by type
 * @param {Function} props.onClose - Close handler
 */
const UserFormsModal = ({ isOpen, userForms, onClose }) => {
  if (!isOpen || !userForms) return null;

  const getTotalForms = () => {
    return Object.keys(userForms).reduce((sum, key) => {
      const forms = userForms[key];
      return sum + (Array.isArray(forms) ? forms.length : 0);
    }, 0);
  };

  const formTypes = Object.keys(userForms).filter((formType) => {
    const forms = userForms[formType];
    return Array.isArray(forms) && forms.length > 0;
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>User Form Submissions</h2>
          <button className="btn-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="forms-summary">
            <div className="summary-stat">
              <span className="stat-value">{getTotalForms()}</span>
              <span className="stat-label">Total Forms</span>
            </div>
          </div>
          <div className="forms-grid">
            {formTypes.length > 0 ? (
              formTypes.map((formType, index) => {
                const forms = userForms[formType];
                const count = Array.isArray(forms) ? forms.length : 0;

                return (
                  <div key={index} className="form-type-card">
                    <div className="form-type-header">
                      <span className="form-type-name">{formType}</span>
                      <span className="form-type-count">{count}</span>
                    </div>
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  color: '#718096',
                  textAlign: 'center',
                  padding: '20px',
                }}
              >
                No forms submitted by this user
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

UserFormsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  userForms: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

UserFormsModal.defaultProps = {
  userForms: null,
};

export default UserFormsModal;
